"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleName = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var lodash_1 = __importDefault(require("lodash"));
var fields = ['name', 'registerNumber', 'VIN', 'brand', 'model'];
var hasFields = function (vehicle) {
    for (var i = 0; i < fields.length; i++) {
        if (!lodash_1.default.has(vehicle, fields[i])) {
            return false;
        }
    }
    return true;
};
var VehicleName = function (_a) {
    var vehicle = _a.vehicle;
    if (!hasFields(vehicle))
        throw new Error("[VehicleName] missing fields ".concat(fields.join(', ')));
    var name;
    if (vehicle.brand && vehicle.model) {
        name = "".concat(vehicle.brand, " ").concat(vehicle.model);
    }
    else if (vehicle.name) {
        name = vehicle.name;
    }
    else if (vehicle.registerNumber) {
        name = vehicle.registerNumber;
    }
    else if (vehicle.VIN) {
        name = vehicle.VIN;
    }
    else {
        name = 'Ajoneuvo';
    }
    var extra;
    if (vehicle.brand && vehicle.model) {
        if (vehicle.name && vehicle.name !== name)
            extra = vehicle.name;
        else if (vehicle.registerNumber && vehicle.registerNumber !== name) {
            extra = vehicle.registerNumber;
        }
        else if (vehicle.VIN && vehicle.VIN !== name)
            extra = vehicle.VIN;
    }
    else {
        var secondary = [vehicle.name, vehicle.registerNumber, vehicle.VIN].filter(function (x) { return x && x !== name; });
        if (secondary.length)
            extra = secondary.join(', ');
    }
    if (extra) {
        name = "".concat(name, " (").concat(extra, ")");
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: name });
};
exports.VehicleName = VehicleName;
